import { render, staticRenderFns } from "./EditPersonal.vue?vue&type=template&id=6cf35aa3&scoped=true&"
import script from "./EditPersonal.vue?vue&type=script&lang=js&"
export * from "./EditPersonal.vue?vue&type=script&lang=js&"
import style0 from "./EditPersonal.vue?vue&type=style&index=0&id=6cf35aa3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf35aa3",
  null
  
)

export default component.exports